var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-backtop'),_c('HeadNav',{staticClass:"global-header"}),_c('div',{staticClass:"main-container"},[_c('router-view')],1),_c('BottomNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }